/**
 * @packageDocumentation
 * @module dom/model
 */

import set_attrs, { TAttrs } from '../attribute/set_attrs';
import query_one from '../element/query_one';
import write from '../database/write';

export interface Create {
  /**
   * create an element and add attributes on the next render
   */
  (query: Element | string, tagName: string, attrs?: TAttrs): HTMLElement;
}

/**
 * { @link Create }
 */
export default (query: Element | string | null, tagName: string, attrs: TAttrs = {}): HTMLElement => {
  const parentEl = query === null ? null : typeof query === 'string' ? query_one(query) : query;
  const newEl = document.createElement(tagName);

  write(() => set_attrs(newEl, attrs));

  if (parentEl) {
    parentEl.appendChild(newEl);
  }

  return newEl;
};
